import { render, staticRenderFns } from "./EditAvatarItem.vue?vue&type=template&id=bba2bcd0&"
import script from "./EditAvatarItem.vue?vue&type=script&lang=js&"
export * from "./EditAvatarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports